<template>
  <SubNavCardVue :buttons="buttons" />
</template>

<script>
import SubNavCardVue from "../../components/cards/SubNavCard.vue";

export default {
  components: { SubNavCardVue },
  data() {
    return {
      buttons: [
        {
          label: "Paramètres",
          icon: "bi bi-sliders",
          route: "settings-index",
        },
        {
          label: "Nouveau paramètre",
          icon: "bi bi-plus-lg",
          route: "settings-create",
        },
      ],
    };
  },
};
</script>
